import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import ComfirmationBox from '../shared/ConfirmationBox';
import { ButtonContainer, ModalBodyContainer, customStyles } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request from '../../utils/request';

const SessionTimeout = ({ children }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    SessionTimeout: { alertTitle, bodyMessage, buttonText }
  } = localizedStrings;
  const [isOpen, setOpen] = useState(false);

  const unlockOrders = () => {
    const pathName = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const stepNumber = urlParams.get('step') || 1;

    if (
      !(
        pathName.includes('Order_Details') ||
        (pathName.includes('Business_Connect_Quote_Tool') && +stepNumber === 2)
      )
    )
      request.get('/orders/unlock');
  };

  const checkTokenExpiry = () => {
    const tokenExpiry = localStorage.getItem('tokenExpiry');
    if (tokenExpiry && Date.now() > parseInt(tokenExpiry, 10)) {
      // Token has expired
      if (localStorage.getItem('accessToken') !== null) {
        unlockOrders();
        setOpen(true);
      }
    }
  };

  const checkTokenInterceptors = () => {
    // Fallback check for 403 responses caught by axios interceptor
    if (localStorage.getItem('isExpired') === 'true') {
      if (localStorage.getItem('accessToken') !== null) {
        unlockOrders();
        setOpen(true);
      }
    }
  };

  const handleLogin = () => {
    setOpen(false);
    localStorage.clear();
    window.location.pathname = '/';
  };

  useEffect(() => {
    let sessionInterval;
    if (localStorage.getItem('accessToken') !== null) {
      // Check token expiry every 30 seconds (no API calls needed)
      sessionInterval = setInterval(() => {
        checkTokenExpiry();
        checkTokenInterceptors();
      }, 5000);
    } else {
      clearInterval(sessionInterval);
    }
  }, []);

  return (
    <>
      {children}
      <ComfirmationBox
        hideCloseButton
        open={isOpen}
        setOpen={setOpen}
        customStyles={customStyles}
        header={alertTitle}
      >
        <ModalBodyContainer>
          <text>{bodyMessage}</text>
          <ButtonContainer>
            <Button onPress={handleLogin}>{buttonText}</Button>
          </ButtonContainer>
        </ModalBodyContainer>
      </ComfirmationBox>
    </>
  );
};

SessionTimeout.propTypes = {
  children: PropTypes.node.isRequired
};

export default SessionTimeout;
